import { Text, VStack } from "@chakra-ui/react";
import { getItemKey, type ListItem } from "../getIconInfo";
import { CommandItem, commandOptionId } from "./CommandItem";

interface CommandGroupProps {
  label: string;
  items: ListItem[];
  startIndex: number;
  selectedIndex: number;
  onSelect: (item: ListItem) => void;
  onMouseEnter: (index: number) => void;
  listId: string;
}

/**
 * A group of palette results under its label ("Go to", "Actions",
 * "Recent"): the label at `--text-12` medium in Text 3, sentence case, and
 * the rows under it as one `group` of options.
 *
 * Spec: specs/design-system/ledger-shell.feature
 */
export function CommandGroup({
  label,
  items,
  startIndex,
  selectedIndex,
  onSelect,
  onMouseEnter,
  listId,
}: CommandGroupProps) {
  if (items.length === 0) return null;
  const labelId = `${listId}-group-${startIndex}`;

  return (
    <VStack align="stretch" gap={0} role="group" aria-labelledby={labelId}>
      <Text
        id={labelId}
        fontSize="var(--text-12)"
        fontWeight="medium"
        color="var(--color-fg-3)"
        paddingX="var(--space-5)"
        paddingTop="var(--space-3)"
        paddingBottom="var(--space-1)"
      >
        {label}
      </Text>
      {items.map((item, i) => (
        <CommandItem
          key={getItemKey(item)}
          id={commandOptionId({ listId, index: startIndex + i })}
          item={item}
          index={startIndex + i}
          isSelected={startIndex + i === selectedIndex}
          onSelect={onSelect}
          onMouseEnter={onMouseEnter}
        />
      ))}
    </VStack>
  );
}
